import { API_RESPONSE, PLAYMATEZAPI } from "services/apiConstant";
import api from "../../services";
import { toast } from "react-toastify";
const { createSlice } = require("@reduxjs/toolkit");

const slice = createSlice({
  name: "booking",
  initialState: {
    bookingListData: null,
    bankAccountsData: null,
    paymentCardsData: null,
    venuesList: [],
    playerList: [],
    clubOrAcademyList: [],
  },
  reducers: {
    apiFetching: (state, action) => {
      state.isLoading = true;
    },
    apiFailed: (state, action) => {
      state.isLoading = false;
      if (action.payload == "addUpdateVenue") {
        state.isUpdateVenueLoading = false;
      }
      if (action.payload == "delete") {
        state.isDeleteAccountLoading = false;
      }
    },
    // booking list
    getBookingListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.bookingListData = action.payload?.data;
      } else {
        state.bookingListData.data = state.bookingListData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    // payment cards and banks data
    getPaymentCardsListSuccess: (state, action) => {
      const cards = Array.isArray(action.payload) ? action.payload : [];

      state.paymentCardsData = [
        ...cards.filter((c) => c.defaultCard === true),
        ...cards.filter((c) => c.defaultCard !== true),
      ];
    },
    getBankAccountListSuccess: (state, action) => {
      state.bankAccountsData = action.payload;
    },
    // playmatez users list
    getPMUsersListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.playmatezUserListData = action.payload?.data;
      } else {
        state.playmatezUserListData.data =
          state.playmatezUserListData.data.concat(action.payload?.data?.data);
      }
    },
    SendConnectRequestSuccess: (state, action) => {
      const index = state.playmatezUserListData.data.findIndex(
        (item) => item.id == action.payload
      );
      if (index != -1) {
        state.playmatezUserListData.data[index].connectionData = {
          status: 0,
        };
      }
    },
    disConnectConnectionSuccess: (state, action) => {
      state.playmatezConnectionList.data =
        state.playmatezConnectionList.data?.filter(
          (item) => item?.sId != action.payload
        );
    },
    getAcceptConnectionListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.playmatezConnectionList = action.payload?.data;
      } else {
        state.playmatezUserListData.data =
          state.playmatezConnectionList.data.concat(action.payload?.data?.data);
      }
    },
    getPaymentHistorySuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.paymentHistoryData = action.payload?.data;
      } else {
        state.playmatezUserListData.data = state.paymentHistoryData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    getPostingListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.postingListData = action.payload?.data;
      } else {
        state.postingListData.data = state.postingListData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    getEventDetailsSuccess: (state, action) => {
      state.eventDetailsData = action.payload;
    },
    deleteEventSuccess: (state, action) => {
      if (action.payload.type === "request") {
        state.requestListData.data = (state.requestListData?.data || []).filter(
          (item) => item?.cardId != action?.payload?.id
        );
      } else {
        state.postingListData.data = (state.postingListData?.data || []).filter(
          (item) => item?.cardId != action?.payload?.id
        );
      }
    },
    getServiceDetailsSuccess: (state, action) => {
      state.serviceDetailsData = action.payload;
    },

    selectCrewOrAssociationSuccess: (state, action) => {
      state.crewAssocialtionList = action.payload;
    },
    fetchVenuesSuccess: (state, action) => {
      state.venuesList = [...action.payload, { id: null, name: "Not listed" }];
    },
    fetchPlayerListSuccess: (state, action) => {
      state.playerList = [...action.payload, { id: "", name: "Not listed" }];
    },
    fetchClubOrAcademyListSuccess: (state, action) => {
      state.clubOrAcademyList = action.payload;
    },
    getAssignedMatchesSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.assignedMatchListData = action.payload?.data;
      } else {
        state.assignedMatchListData.data =
          state.assignedMatchListData.data.concat(action.payload?.data?.data);
      }
    },
    getRequestSentListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.requestListData = action.payload?.data;
      } else {
        state.requestListData.data = state.requestListData.data.concat(
          action.payload?.data?.data
        );
      }
    },
  },
});

const {
  apiFetching,
  apiFailed,
  getBookingListSuccess,
  getBankAccountListSuccess,
  getPaymentCardsListSuccess,
  getPMUsersListSuccess,
  SendConnectRequestSuccess,
  disConnectConnectionSuccess,
  getAcceptConnectionListSuccess,
  getPostingListSuccess,
  getPaymentHistorySuccess,
  getEventDetailsSuccess,
  getServiceDetailsSuccess,
  deleteEventSuccess,
  selectCrewOrAssociationSuccess,
  fetchVenuesSuccess,
  fetchPlayerListSuccess,
  fetchClubOrAcademyListSuccess,
  getAssignedMatchesSuccess,
  getRequestSentListSuccess,
} = slice.actions;
// get booking list

export const getBookingList =
  (requestParams, setLoading) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.booking.getBookingList}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(
            getBookingListSuccess({
              data: result,
              page: requestParams?.page,
            })
          );
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setLoading) {
          setLoading(false);
        }
      })
      .catch(() => {
        if (setLoading) {
          setLoading(false);
        }
        dispatch(apiFailed());
      });
  };

//  create Group
export const createGroup =
  (request, closeGroupCreateDialog) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.group.createGroup}`, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          console.log("result", result);
          toast.success(result.message);
          closeGroupCreateDialog();
          // dispatch(
          //   getBookingListSuccess({
          //     data: result,
          //     page: requestParams?.page,
          //   })
          // );
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

// get  Bank Account List
export const getBankAccountList = (country, type) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .get(`${PLAYMATEZAPI.payment.getBankAccountList}/${country}/${type}`)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(getBankAccountListSuccess(result?.data));
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// get  payment cards List
export const getPaymentCardsList =
  (country, setBookingStatus, setCardLoader, onError) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .get(`${PLAYMATEZAPI.payment.getPaymentCardsList}/${country}`)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(getPaymentCardsListSuccess(result?.data));
          setBookingStatus?.(2);
        } else {
          toast.error(result?.message || "Something Went Wrong");
          onError?.();
        }
        setCardLoader?.(false);
      })
      .catch(() => {
        setCardLoader?.(false);
        onError?.();
        dispatch(apiFailed());
      });
  };

// add payment cards
export const addPaymentCards = (request, handleSuccess) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(PLAYMATEZAPI.payment.addPaymentCards, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        toast.success(result?.message);
        handleSuccess(true);
      } else {
        handleSuccess(false);
        toast.error(result?.message);
      }
    })
    .catch(() => {
      handleSuccess(false);
      dispatch(apiFailed());
    });
};

// set primary  payment card
export const setAsDefaultPaymentMethod =
  (request, handlePrimaryPaymentCardSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.payment.setAsDefaultPaymentMethod, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handlePrimaryPaymentCardSuccess(true);
        } else {
          handlePrimaryPaymentCardSuccess(false);
          toast.error(result?.message);
        }
      })
      .catch(() => {
        handlePrimaryPaymentCardSuccess(false);
        dispatch(apiFailed());
      });
  };

// remove payment card
export const removePaymentMethod =
  (request, handlePrimaryPaymentCardSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.payment.removePaymentMethod, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success("Payment method removed succesfully");
          handlePrimaryPaymentCardSuccess(true);
        } else {
          handlePrimaryPaymentCardSuccess(false);
          toast.error(result?.message);
        }
      })
      .catch(() => {
        handlePrimaryPaymentCardSuccess(false);
        dispatch(apiFailed());
      });
  };

// add Bank Account On RazorPay
export const addBankAccountOnRazorPay =
  (request, handleNavigate, setLoader) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.payment.addBankAccountOnRazorPay, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleNavigate();
        } else {
          toast.error(result?.message);
        }
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        dispatch(apiFailed());
      });
  };

// upload document
export const uploadFileOnLocal =
  (formData, folderName, type) => async (dispatch) => {
    try {
      const response = await api.post(
        `${PLAYMATEZAPI.payment.uploadFileOnLocal}?language=en&folderName=${folderName}&type=${type}&country=AU`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const result = response.data;

      if (result.status === API_RESPONSE.SUCCESS) {
        return result.data; // ✅ THIS WILL RETURN
      } else {
        toast.error(result.message);
        return null;
      }
    } catch (error) {
      toast.error("Something went wrong!");
      return null;
    }
  };

// add Bank Account On stripe
export const addBankAccountOnStripe =
  (request, handleNavigate, setLoader) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.payment.addBankAccountOnStripe, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleNavigate();
        } else {
          toast.error(result?.message);
        }
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        dispatch(apiFailed());
      });
  };

// get Users List for community
export const getPMUsersList = (request, setDialogData) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(PLAYMATEZAPI.community.getPMUsersList, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(
          getPMUsersListSuccess({
            data: result,
            page: request?.page,
          })
        );
      } else {
        toast.error(result?.message);
      }
      if (setDialogData) {
        setDialogData({});
      }
    })
    .catch(() => {
      if (setDialogData) {
        setDialogData({});
      }
      dispatch(apiFailed());
    });
};

// Send Connect Request
export const SendConnectRequest =
  (requestId, handleSuccess) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.community.SendConnectRequest}?requestUserId=${requestId}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(SendConnectRequestSuccess(requestId));
          toast.success(result.message);
        } else {
          toast.error(result?.message);
        }
        handleSuccess();
      })
      .catch(() => {
        handleSuccess();
        dispatch(apiFailed());
      });
  };
// disconnect connection
export const disConnectConnection =
  (request, handleSuccess) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.community.disConnectConnection, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(disConnectConnectionSuccess(request?.connectUserId));
          toast.success(result.message);
        } else {
          toast.error(result?.message);
        }
        handleSuccess();
      })
      .catch(() => {
        handleSuccess();
        dispatch(apiFailed());
      });
  };

// accept Connection Request
export const acceptConnectionRequest =
  (requestUserId, requestId, status,cardType,cardReferenceID, handleSuccess) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.community.acceptConnectionRequest}?requestUserId=${requestUserId}&status=${status}&requestId=${requestId}&cardType=${cardType}&cardReferenceID=${cardReferenceID}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result.message);
          handleSuccess(true);
        } else {
          handleSuccess(false);
          toast.error(result?.message);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };

// get community connection list
export const getAcceptConnectionList =
  (page, perPage, search) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.community.getAcceptConnectionList}?page=${page}&perPage=${perPage}&search=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(
            getAcceptConnectionListSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result?.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

// get community connection list
export const getPaymentHistory = (request, setLoader) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.payment.getPaymentHistory, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(
          getPaymentHistorySuccess({
            data: result,
            page: request?.page,
          })
        );
      } else {
        toast.error(result?.message);
      }
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
      dispatch(apiFailed());
    });
};

// download Sale Excel
export const downloadSaleExcel = (request) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.payment.downloadSaleExcel, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        if (!result?.link) return toast.error("Something went wrong!");
        const link = document.createElement("a");
        link.href = result?.link;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        toast.error(result?.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// add Product Rating Reviews
export const addProductRatingReviews =
  (request, setRatingData) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.payment.addProductRatingReviews, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          setRatingData({});
        } else {
          toast.error(result?.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

// create event
export const createEvent = (request, handleSuccess) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.event.createEvent, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        toast.success(result?.message);
        handleSuccess(true);
      } else {
        toast.error(result?.message);
        handleSuccess(false);
      }
    })
    .catch(() => {
      handleSuccess(false);
      dispatch(apiFailed());
    });
};

// update event
export const updateEvent = (request, handleSuccess) => async (dispatch) => {
  api
    .put(PLAYMATEZAPI.event.updateEvent, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        toast.success(result?.message);
        handleSuccess(true);
      } else {
        toast.error(result?.message);
        handleSuccess(false);
      }
    })
    .catch(() => {
      handleSuccess(false);
      dispatch(apiFailed());
    });
};

// create services
export const createRequestService =
  (request, handleSuccess) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.event.createRequestService, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleSuccess(true);
        } else {
          toast.error(result?.message);
          handleSuccess(false);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };
// update service
export const updateRequestService =
  (request, handleSuccess) => async (dispatch) => {
    api
      .put(PLAYMATEZAPI.event.updateRequestService, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleSuccess(true);
        } else {
          toast.error(result?.message);
          handleSuccess(false);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };

// create request match
export const createRequestMatch =
  (request, handleSuccess) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.event.createRequestMatch, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleSuccess(true);
        } else {
          toast.error(result?.message);
          handleSuccess(false);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };

// update request match
export const updateRequestMatch =
  (request, handleSuccess) => async (dispatch) => {
    api
      .put(PLAYMATEZAPI.event.updateRequestMatch, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          handleSuccess(true);
        } else {
          toast.error(result?.message);
          handleSuccess(false);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };
// select Crew Or Association
export const selectCrewOrAssociation =
  (request, handleSuccess) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.event.selectCrewOrAssociation, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(selectCrewOrAssociationSuccess(result.data));
        } else {
          toast.error(result?.message);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };

// get my posting  list
export const getPostingList =
  (page, perPage, search, setLoading) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.dashboard.getPostingList}?page=${page}&perPage=${perPage}&searchQuery=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(
            getPostingListSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result?.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        dispatch(apiFailed());
      });
  };

// get event details
export const getEventDetails =
  (eventId, setLoader, handleAction) => async (dispatch) => {
    api
      .get(`${PLAYMATEZAPI.dashboard.getEventDetails}?eventId=${eventId}`)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(getEventDetailsSuccess(result?.data));
          if (handleAction) {
            handleAction(result?.data);
          }
        } else {
          dispatch(getEventDetailsSuccess(null));
          toast.error(result?.message);
          if (handleAction) {
            handleAction();
          }
        }
        if (setLoader) {
          setLoader(false);
        }
      })
      .catch(() => {
        dispatch(getEventDetailsSuccess(null));
        if (setLoader) {
          setLoader(false);
        }
        if (handleAction) {
          handleAction();
        }
        dispatch(apiFailed());
      });
  };
// clear event details
export const clearEventDetails = (eventId, setLoader) => async (dispatch) => {
  dispatch(getEventDetailsSuccess(null));
};

// get service details
export const getServiceDetails =
  (eventId, setLoader, setShowDialog) => async (dispatch) => {
    api
      .get(`${PLAYMATEZAPI.dashboard.getServiceDetails}?serviceId=${eventId}`)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(getServiceDetailsSuccess(result?.data));
          if (setShowDialog) {
            setShowDialog(true);
          }
        } else {
          dispatch(getServiceDetailsSuccess(null));
          toast.error(result?.message);
        }
        setLoader(false);
      })
      .catch(() => {
        dispatch(getServiceDetailsSuccess(null));
        setLoader(false);
        dispatch(apiFailed());
      });
  };
// clear service details
export const clearServiceDetails = (eventId, setLoader) => async (dispatch) => {
  dispatch(getServiceDetailsSuccess(null));
};
// get Assigned matcheslist
export const getAssignedMatches =
  (page, perPage, search, setLoading) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.dashboard.getAssignedMatches}?page=${page}&perPage=${perPage}&searchQuery=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(
            getAssignedMatchesSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result?.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        dispatch(apiFailed());
      });
  };

// get request sent list
export const getRequestSentList =
  (page, perPage, search, setLoading) => async (dispatch) => {
    api
      .get(
        `${PLAYMATEZAPI.dashboard.getRequestSentList}?page=${page}&perPage=${perPage}&searchQuery=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          console.log(result, "sss");
          dispatch(
            getRequestSentListSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result?.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        dispatch(apiFailed());
      });
  };

//  delete  event

// delete user account
export const deleteEvent =
  (request, handleSuccess, type) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venueOperation.deleteBooking, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          toast.success(result?.message);
          dispatch(deleteEventSuccess({ id: request?.id, type: type }));
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        handleSuccess();
      })
      .catch(() => {
        handleSuccess();
      });
  };

export const fetchVenues = (request, handleSuccess) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.venue.venueAddressSearch, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(fetchVenuesSuccess(result?.data));
      } else {
        dispatch(fetchVenuesSuccess([]));
      }
      // handleSuccess();
    })
    .catch(() => {
      dispatch(fetchVenuesSuccess([]));
    });
};

export const fetchPlayerList = (request, handleSuccess) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.venue.getAllPlayerList, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(fetchPlayerListSuccess(result?.data));
      } else {
        dispatch(fetchPlayerListSuccess([]));
      }
      // handleSuccess();
    })
    .catch(() => {
      dispatch(fetchPlayerListSuccess([]));
    });
};

export const createGameOn = (request, navigate, setLoader) => async () => {
  api
    .post(PLAYMATEZAPI.venue.createGameOn, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        toast.success(result?.message);
        navigate("/");
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
      setLoader(false);
    })
    .catch(() => {
      // handleSuccess();
    });
};

export const editGameOn = (request, navigate, setLoader) => async () => {
  api
    .put(PLAYMATEZAPI.venue.editGameOn, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        toast.success(result?.message);
        navigate("/");
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
      setLoader(false);
    })
    .catch(() => {
      // handleSuccess();
    });
};

export const fetchClubOrAcademyList = (request) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.venue.selectClubOrAcademy, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(fetchClubOrAcademyListSuccess(result.data));
      } else {
        toast.error(result?.message);
        dispatch(fetchClubOrAcademyListSuccess([]));
      }
    })
    .catch((e) => {
      dispatch(apiFailed());
      dispatch(fetchClubOrAcademyListSuccess([]));
    });
};

export const holdVenueSlots = (request) => async (dispatch) => {
  try {
    const response = await api.post(PLAYMATEZAPI.venue.holdSlots, request);
    const result = response.data;

    if (result?.status) {
      return result?.data;
    }

    toast.error(result?.message || "Unable to hold selected slots");
    return null;
  } catch (e) {
    dispatch(apiFailed());
    toast.error("Unable to hold selected slots");
    return null;
  }
};

export const unholdVenueSlots =
  (request, showError = false) => async (dispatch) => {
    try {
      const response = await api.post(PLAYMATEZAPI.venue.unholdSlots, request);
      const result = response.data;

      if (result?.status) {
        return true;
      }

      if (result?.message === "hold_not_found") {
        return true;
      }

      if (showError) {
        toast.error(result?.message || "Unable to release held slots");
      }
      return false;
    } catch (e) {
      dispatch(apiFailed());
      if (showError) {
        toast.error("Unable to release held slots");
      }
      return false;
    }
  };

export const onBookVenue =
  (request, onCreateVenue, setShowSuccess, setLoader, setPaymentDetails, onFailure) => async (dispatch) => {
    try {
      const response = await api.post(
        PLAYMATEZAPI.venue.slotAndEventBookingFromUsersSide,
        request
      );
      let result = response.data;
      console.log('result == ', result);

      if (result?.status) {
        setShowSuccess(true);
        onCreateVenue(result?.data);
        setPaymentDetails(result?.data);
        return result?.data;
      }

      toast.error(result?.message || "Something Went Wrong");
      onFailure?.();
      return null;
    } catch (e) {
      dispatch(apiFailed());
      onFailure?.();
      return null;
    } finally {
      setLoader(false);
    }
  };

export const collectPaymentOfflineBooking =
  (request, setLoader) => async (dispatch) => {
    try {
      setLoader?.(true);
      const response = await api.post(
        PLAYMATEZAPI.venue.collectPaymentOfflineBooking,
        request
      );
      const result = response.data;

      if (result?.status) {
        toast.success(result?.message || "Payment link sent successfully");
        return result?.data;
      }

      toast.error(result?.message || "Unable to send payment link");
      return null;
    } catch (e) {
      dispatch(apiFailed());
      toast.error("Unable to send payment link");
      return null;
    } finally {
      setLoader?.(false);
    }
  };

export const createVenue = (request) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.venue.createVenue, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
      } else {
        toast.error(result?.message);
      }
    })
    .catch((e) => {
      dispatch(apiFailed());
    });
};

export const onVenueReschedulePayment =
  (request, setLoading, fetchNotificationList) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venue.venueReschedulePayment, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
        } else {
          toast.error(result?.message);
        }
        setLoading(false);
        fetchNotificationList()
      })
      .catch((e) => {
        dispatch(apiFailed());
      });
  };

export default slice.reducer;
